import React, { createContext, useContext, useState } from 'react';

const PedidoContext = createContext();

export const PedidoPovider = ({ children }) => {

  const defaultProduto = {
    nome: null,
    descricao: null,
    pacotes: null,
    peso: null,
    pesoFardo: null,
    preco: null,
    fotoProduto: null,
    quantidade: 0,
    status: null,
    porcentagemDescontoDeVolume: 0,
    valorDescontoDeVolume: 0.0,
    isDescontoDeVolumeAplicado: false,
    valorTotalProduto: 0
  };

  const defaultPagamento = {
    aVista: true,
    nomePagamento: 'À Vista',
    descricaoPagamento: null,
    diasPrimeiraParcela: null,
    qtdeParcelas: null,
    intervaloParcelas: null,
  };

  const defaultPedido = {
    produtos: [defaultProduto],
    formaPagamento: defaultPagamento,
    usuario: '',
    frete: 'CIF',
    descontoAplicado: false,
    jurosAplicado: false,
    descontoCalculado: 0.0,
    jurosCalculado: 0.0,
    valor: 0.0,
    observacao: null,
    parcelas: []
  };

  const defaultFaturarPedido = {
    id: 0,
    vendedor: {},
    status: 0,
    data: "",
    valor: 0.0,
    frete: "",
    observacao: null,
    anexosNF: [],
    anexosCanhoto: [],
    cliente: {},
    pagamento: {},
    itemOrcamento: [],
    descStatus: ""
  };

  const defaultConfig = {
    descontoVista: 0.02,
    juros: 0.02,
    tempoMedio: 28
  }

  //Retorna Do Back
  const [produtos, setProdutos] = useState([defaultProduto]);
  //Escolhe o produto para adicionar 
  const [produtoSelecionado, setProdutoSelecionado] = useState(defaultProduto);
  //Forma de pagamento 
  const [formaPagamento, setFormaPagamento] = useState(defaultPagamento);
  //Criação de pedido
  const [pedido, setPedido] = useState(defaultPedido);
  //Listagem de Pedidos
  const [pedidos, setPedidos] = useState([defaultPedido]);
  //Pedido para atualizar o estado 
  const [pedidoId, setPedidoId] = useState(defaultFaturarPedido);
  //Produtos que serão selecionados para criar o pedido
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  //Abre o formulario do Produto
  const [formProduto, setFormProduto] = useState(false);
  //Abre o seletor de produto

  const [seletorProduto, setSeletorProduto] = useState(false);

  const [valueIndex, setValueIndex] = useState(0)

  const [configPagamento, setConfigPagamento] = useState(defaultConfig);

  const [edicaoAdicionada, setEdicaoAdicionada] = useState(false);

  const [refreshPedidos, setRefreshPedidos] = useState(false);


  const value = {
    produtos,
    setProdutos,
    produtoSelecionado,
    setProdutoSelecionado,
    produtosSelecionados,
    setProdutosSelecionados,
    formProduto,
    setFormProduto,
    seletorProduto,
    setSeletorProduto,
    formaPagamento,
    setFormaPagamento,
    pedido,
    setPedido,
    pedidos,
    setPedidos,
    pedidoId,
    setPedidoId,
    defaultPedido,
    defaultPagamento,
    valueIndex,
    setValueIndex,
    configPagamento,
    setConfigPagamento,
    edicaoAdicionada,
    setEdicaoAdicionada,
    defaultConfig,
    refreshPedidos, setRefreshPedidos
  }

  return (
    <PedidoContext.Provider value={value}>
      {children}
    </PedidoContext.Provider>
  )
}

export const usePedidoContext = () => {
  const context = useContext(PedidoContext);
  if (!context) {
    throw new Error('useProductContext deve ser usado com um ProdutoProvider')
  }
  return context;
}